export enum SourceType {
  Source = 'SOURCE',
  Manual = 'MANUAL',
}
